import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import HeaderTransprent from "../../components/HeaderTransprent";
import "aos/dist/aos.css";
import Footer from "../../components/Footer";
import moment from "moment";
import JsonData from "../../JsonData/jsonData.json";

const Blog = () => {

  const history = useHistory();

  const handleRedirect = (path) => {
    history.push(path);
  };

  const handleReadMore = (item) => {
    history.push(`/newsdetails/${item.id}`);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Happiest Workplaces News - Latest Insights on Employee Happiness and Workplaces Culture</title>
        <meta name="description" content="Stay up-to-date with the latest news and trends on the happiest workplaces around the world. Discover tips, success stories, and expert advice on fostering a positive work environment and enhancing employee happiness." />
        <link rel="canonical" href="https://happiestworkplaces.in/#/news" />
      </Helmet>

      <HeaderTransprent />
      <section className="bg-[#2196F3]/10 w-full h-auto bg-cover bg-no-repeat bg-right" style={{ backgroundImage: `url('/img/home/sub-header-bg.webp')`, }}>
        <div className="w-full h-full">
          <div className="flex flex-col w-full h-full py-20 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div data-aos="fade-up" className="space-y-2 text-[#3D405B] flex flex-col justify-center items-center">
              <h2 className="xl:text-6xl text-5xl leading-[3rem] xl:leading-[3.5rem] font-bold textcolor capitalize">In The News</h2>
              <div className="flex items-center space-x-2 pt-4">
                <p className="cursor-pointer" onClick={() => handleRedirect("/home")}>  {" Home >"}</p>
                <p className="cursor-pointer" onClick={() => handleRedirect("news")}>  {" News"}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="grid w-full h-full grid-cols-1 gap-4 px-4 py-10 mx-auto 2xl:gap-10 lg:gap-6 md:py-20 2xl:w-9/12 xl:w-11/12 xl:px-0 lg:grid-cols-3 md:grid-cols-2">
        {[...JsonData.hardcodedBlogData]
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          .map((item) => (
            <div key={item.id} onClick={() => handleReadMore(item)} className="flex flex-col cursor-pointer overflow-hidden border hover:border-transparent rounded-xl hover:shadow-[0px_10px_30px_rgba(0,0,0,0.10)]">
              <img src={item.image} className="w-full" alt="Blog" />
              <div className="p-6 space-y-4">
                <div className="flex items-center space-x-2 text-[#212121]/70 text-base">
                  <span>By {item.author}</span>
                  <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-point-filled text-[#3D405B]/30" width="16" height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">  <path stroke="none" d="M0 0h24v24H0z" fill="none" />  <path d="M12 7a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z" strokeWidth="0" fill="currentColor" /></svg>
                  <span>{moment(item.createdAt).format("DD MMMM, YYYY")}</span>
                </div>

                <h1 className="xl:text-2xl text-xl font-semibold text-[#212121] capitalize line-clamp-2">{item.title}</h1>
                <div className="text-base font-light md:text-lg">
                  <p className="text-[#212121] line-clamp-3 capitalize" dangerouslySetInnerHTML={{ __html: item.desc }} />
                </div>
                <button className="textcolor flex font-medium pt-6 space-x-2 hover:text-[#183889]" onClick={() => handleReadMore(item)}>
                  <span>Read More</span>
                  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" className="text-[1.5rem]" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">  <line x1="7" y1="17" x2="17" y2="7"></line>  <polyline points="7 7 17 7 17 17"></polyline></svg>
                </button>
              </div>
            </div>
          ))}
      </div>

      {/* <Ready /> */}
      <Footer />
    </>
  );
};

export default Blog;